import { render, staticRenderFns } from "./contactusB2BList.vue?vue&type=template&id=22397a5a"
import script from "./contactusB2BList.vue?vue&type=script&lang=js"
export * from "./contactusB2BList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports